<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM各类别板材销量 left_1"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')} 合计：${total_num}`"
      :tooltipText="'预优化开单实时板材数量'"
    ></chart-title>

    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="left_1" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import { getCategorySort } from "@/api/cockpit/jyl";
import resize from "@/utils/resize";
import {
  formatTime,
  getNextMonth,
  getLastDate,
  getFirstDate,
  arrDataFormat,
} from "@/utils/index";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "left_1",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      date: new Date(),
      total_num: 0,
      chartData: [],
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    //获取数据
    getData() {
      const data = {
        time_range: [
          getFirstDate(this.date, "yyyy-MM-dd"),
          getLastDate(this.date, "yyyy-MM-dd"),
        ],
      };
      getCategorySort(data).then((resp) => {
        const list = arrDataFormat(resp.data.list);
        this.chartData = list.filter((m, index) => index <= 9);
        this.total_num = resp.data.total_num;
        this.initChart();
      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_1"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: "3%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
          // formatter: (name) => {
          //   const value = this.chartData.find((m) => m.name == name).value;
          //   return `${name}：${value}`;
          // },
        },
        color: [
          "#1158a7",
          "#4682B4",
          "#0983ff",
          "#59abf6",
          "#abd6fc",
          "#29beb9",
          "#3bffd0",
          "#22e4ff",
          "#40E0D0",
          "#AFEEEE",
        ],
        series: [
          {
            name: "PDM各类别板材工厂用量",
            type: "pie",
            radius: "42%",
            center: "center",
            top: "-10%",
            data: this.chartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              // show: false,
              formatter: "{b}:  {@2012}",
              color: "#C0C4CC",
            },
          },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 40vh;
  #left_1 {
    height: 100%;
  }
}
</style>
